import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

const solutionsSliderSettings = {
	modules: [Navigation, Pagination],
	autoHeight: true,
	slidesPerView: 1,
	spaceBetween: 30,
	threshold: 20,
	navigation: {
		nextEl: '.solutions-list__slider-arrows .swiper__next',
		prevEl: '.solutions-list__slider-arrows .swiper__prev',
	},
	pagination: {
		el: document.querySelector('.solutions-list__slider').querySelector('.swiper-pagination'),
		type: 'progressbar',
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 50,
		},
		1024: {
			slidesPerView: 2,
			spaceBetween: 114,
		},
		1600: {
			slidesPerView: 2,
			spaceBetween: 170,
		},
	},
};
let solutionsSlider = new Swiper('.solutions-list__slider .swiper', solutionsSliderSettings);

const solutionsSliderSwitch = document.querySelector('.slider-switch');
solutionsSliderSwitch.addEventListener('click', (event) => {
	event.preventDefault();
	if (solutionsSlider.destroyed) {
		document.querySelector('.solutions-list__slider').classList.remove('solutions-list__slider--grid');
		document.querySelector('.solutions-list__slider').classList.add('has-custom-cursor');
		document.querySelector('.solutions-list__slider').classList.add('has-custom-cursor--drag');
		solutionsSlider = new Swiper('.solutions-list__slider .swiper', solutionsSliderSettings);
		solutionsGridSwitch.classList.remove('active');
		solutionsSliderSwitch.classList.add('active');
		ScrollTrigger.refresh(); // recalculate section height and update any scroll triggers on the page i.e. apply now cta
	}
});

const solutionsGridSwitch = document.querySelector('.grid-switch');
solutionsGridSwitch.addEventListener('click', (event) => {
	event.preventDefault();
	console.log(solutionsGridSwitch.classList);
	if (solutionsSlider.enabled) {
		solutionsSlider.destroy();
		document.querySelector('.solutions-list__slider').classList.add('solutions-list__slider--grid');
		document.querySelector('.solutions-list__slider').classList.remove('has-custom-cursor');
		document.querySelector('.solutions-list__slider').classList.remove('has-custom-cursor--drag');
		solutionsSliderSwitch.classList.remove('active');
		solutionsGridSwitch.classList.add('active');
		ScrollTrigger.refresh(); // recalculate section height and update any scroll triggers on the page i.e. apply now cta
	}
});
